export default "__VITE_ASSET__UEHcSpXz__"